import { FieldState } from 'formstate';
import { IItemMultiple } from 'welltrax-ui-components/lib/types/Form/Inputs/SelectMultipleField';
import { orderBy } from 'lodash';
import { intl } from '../../../../../core/utils/Intl';
import { numberGreaterThan, numberLesserThan } from '../../../../../core/utils/utilsForm';
import { DropDown, ISelect, OptionsEntity } from '../types/types';

export const validateMaxValue =
  (func: (maxValue: number) => boolean) => (maxValue?: number, minValue?: number) => (value: any) => {
    return !!(maxValue || minValue) && func(maxValue || 0) && numberLesserThan(maxValue || 0)(value);
  };

export const validateMinValue =
  (func: (minValue: number) => boolean) => (minValue?: number, maxValue?: number) => (value: any) => {
    return !!(maxValue || minValue) && func(minValue || 0) && numberGreaterThan(minValue || 0)(value);
  };

export const convertStringToKey = (fieldName: string) => {
  return fieldName.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').replace(/ /g, '_');
};

export const removeDotStringKey = (key: string) => {
  return key.replace(/\./g, '');
};

export const generateUniqueSource = (id: string | number) => {
  return `dynamicFieldsToColumn_${id}`;
};

export const getToolTip = (text: any) => {
  return `${text}`.replace(/:/g, ' ');
};

export const getActualDynamicField = (id: any, dynamicFields: any): FieldState<any> | undefined => {
  let fieldState: FieldState<any> | undefined = undefined;
  Object.keys(dynamicFields).some(key => {
    const splitted = key.split('_');
    const result = splitted.length > 0 && splitted[splitted.length - 1] === `${id}`;
    if (result) {
      fieldState = dynamicFields[key];
    }
    return result;
  });
  return fieldState;
};

export const getSelectProps = (props: Partial<DropDown>): ISelect => {
  const options: IItemMultiple[] = [];
  let defaultValue: string | number = '';
  const mapperOptions =
    (!!props?.suppressInactiveOptions ? props?.options?.filter((it: OptionsEntity) => !!it?.active) : props?.options) ??
    [];

  orderBy(mapperOptions, 'orderIndex').forEach?.((item: OptionsEntity) => {
    const originLabel = `${item.optionName}`.toUpperCase();
    const label =
      !item.hasOwnProperty('active') || !!item?.active ? originLabel : `${originLabel} ${intl('app.statusInactive')}`;
    options.push({
      label,
      value: item.optionId
    });
    if (label === `${props.defaultStringValue}`.toUpperCase()) {
      defaultValue = item.optionId;
    }
  });
  return { options, defaultValue };
};
